import Axios, {Canceler} from "axios";

const CancelToken = Axios.CancelToken;

class MerchantOnboardingStatus {
    private _cancel: Canceler | null = null;


    private readonly _cancelToken = new CancelToken((c) => {
        this._cancel = c;
    });

    postUserInformation = async (url: string, postData: {}, successCallback: (response: any) => void, errorCallback?: (error: {} | string | undefined) => void) => {
        Axios.post(url, postData, {cancelToken: this._cancelToken})
            .then((response) => {
                return successCallback(response.data);
            }).catch((error) => {
            if (errorCallback) {
                if(error.response && error.response.data) return errorCallback(error.response.data);
                return errorCallback(error);
            }
        });
    }
}

export default MerchantOnboardingStatus;